
<template>
  <div class="container box">
    <div class="">
      <div class="">

        <h1 class="is-size-4 mt-3 mb-5">Manage Travel Policies</h1>

        <!-- <div class="columns is-mobile head1 is-gant" style="border-radius: 5px">
          <div class="column" style="text-align: center">
            <h1 class="title is-4" style="color: white">
              <b-icon icon="file"> </b-icon> Your Travel Policies
            </h1>
          </div>
        </div> -->

        <div class="h1" v-if="isTravelChampion">
          <b-button
            @click="createTravelPolicy()"
            class="button is-primary"
            style="float: right"
            >Create New Policy</b-button
          >

          
        </div>
        <br /><br />

        <div v-if="loading">
          <b-loading
            :is-full-page="false"
            :active="loading"
            :can-cancel="true"
          ></b-loading>
        </div>
        <div>
          <div v-if="!loading && policies.length > 0">
            <b-table :data="policies" ref="table" detail-key="id" :default-sort="['lastModifiedDate','desc']" default-sort-direction="desc">
              <b-table-column
                field="ruleClass"
                label="Policy Name"
                sortable
                v-slot="props"
              >
                <a @click="showPolicy(props.row.id)">
                  {{ props.row.ruleClass }}
                </a>
              </b-table-column>

              <b-table-column
                field="status"
                label="Status"
                sortable
                v-slot="props"
              >
                <span
                  :class="
                        [
                            'tag',
                            {'is-danger': props.row.status== 'In-Active'},
                            {'is-success':  props.row.status== 'Active'}
                        ]"
                >
                  {{ props.row.status }}
                </span>
              </b-table-column>

              <b-table-column
                field="lastModifiedDate"
                label="Last Updated"
                sortable
                v-slot="props"
              >
                {{ props.row.lastModifiedDate |formatDate }}
              </b-table-column>

              <b-table-column v-slot="props">
                <div class="action-links">
                  <a @click="showPolicy(props.row.id)"> View </a>
                  <a @click="clonePolicy(props.row.id, props.row.ruleClass)"> Clone </a>
                  <a v-if="isTravelChampion && props.row.status === 'Active'" @click="deactivatePolicy(props.row.id)"> Deactivate </a>
                  <a v-if="isTravelChampion && props.row.status === 'In-Active'" @click="activatePolicy(props.row.id)"> Activate </a>
                </div>
              </b-table-column>

              <template #empty>
                <div class="has-text-centered">No travel policies found</div>
              </template>
            </b-table>
          </div>
        </div>
      </div>

      <br />
    </div>
  </div>
</template>

<script>
import CloneTravelPolicy from "./CloneTravelPolicy.vue";

    export default {
      name: 'TravelPolicy',
      data: function () {
        return {
            loading: true,
            policies:[],
        }
    },
      computed: {
        activeUser() {
          return this.$store.getters['app/getActiveUser'];
        },
        isTravelChampion(){
          if(this.activeUser)
            return this.activeUser.isTravelChampion;
          return false;
        }
      },
      methods: {
       
        createTravelPolicy() {
          this.$router.push({ path: '/admin/create-travel-policy' })
        },
        showPolicy(id){
          this.$router.push({ path: '/admin/travel-policy/'+id })
        },
        deactivatePolicy(id){
          var body = {"travelPolicyId": id,"contactId":this.activeUser.id}
          this.$app.huddleLabsServerCall('profile/travel-policy/deactivate', body)
            .then(response => {
                if(response.success)
                  {
                    this.getPolicy();
                    return true;
                  }
                }).catch(error => {
                  console.log('Error deactivating policy');
                });
        },
        activatePolicy(id){
          var body = {"travelPolicyId": id,"contactId":this.activeUser.id}
          this.$app.huddleLabsServerCall('profile/travel-policy/activate', body)
            .then(response => {
                if(response.success)
                  {
                    this.getPolicy();
                    return true;
                  }
                }).catch(error => {
                  console.log('Error activating policy');
                });
        },
        getPolicy() {
          this.loading=true;
          var body = {"accountId": this.activeUser.account.id,"contactId":this.activeUser.id}
          this.$app.huddleLabsServerCall('profile/travel-policy/list', body)
            .then(response => {this.policies = response.data;
            this.loading=false;
            })
        },
        clonePolicy(travelPolicyId, ruleClass){
          let policyNames = [];
          if(this.policies.length > 0){
            policyNames = this.policies.map(policy => policy.ruleClass);
          }
          
          this.$buefy.modal.open({
            parent: this,
            component: CloneTravelPolicy,
            hasModalCard: true,
            customClass: "",
            trapFocus: true,
            props: {
              sourcePolicyId: travelPolicyId,
              sourcePolicyName: ruleClass,
              policyNames: policyNames
            },
            events: {
              save: () => {
                //Reloads policies after policy is cloned.
                this.getPolicy();
                
              },
            },
          });
        },
        capitalize(s) {
          if (typeof s !== 'string')
             return ''
          return s.charAt(0).toUpperCase() + s.slice(1)
        },
      },
      mounted () {
              this.getPolicy();
              console.log(this.activeUser);
      }
    }
</script>
<style scoped>
.action-links a{
  margin-right: 10px;
}

/* Media query for smaller screens */
@media (max-width: 767px) {
  .action-links {
    width: 100%;
    display: flex;
    justify-content: space-evenly; /* Evenly space the links */
  }
}
</style>
